<template>
  <li
    class="px-4 pt-4 pb-2 type-scale-n1 flex items-center justify-between cursor-pointer select-none relative bg-white shadow hover:shadow-md"
    :class="[$style.root, active && $style.activeItem]"
    @click="onClick"
  >
    <div>
      <div class="font-medium">{{ eventType }}</div>
      <div class="type-scale-n4 mt-4 text-gray-80">
        <strong class="font-medium">Källa:</strong> {{ event.metadata.source }}
      </div>
      <div class="type-scale-n4 text-gray-80">
        {{ event.metadata.messagedatetime | format }}
      </div>
    </div>
    <AppTransition name="fade-right">
      <i class="material-icons text-gray-80" v-if="active"
        >keyboard_arrow_right</i
      >
    </AppTransition>
  </li>
</template>

<script>
import format from '@/common/dateFormat'

export default {
  name: 'TimetableSplitViewEventListItem',

  filters: {
    format(date) {
      return format(date, 'YYYY-MM-DD HH:mm')
    }
  },

  props: {
    event: Object
  },

  computed: {
    active() {
      return this.event._id === this.$store.get('trainChange/active')
    },

    eventType() {
      switch (this.event.metadata.handelsetyp) {
        case 'N':
          return 'Nytt tåg'
        case 'A':
          return 'Anordnat'
        case 'IH':
          return 'Inställt'
        case 'ID':
          return 'Inställd delsträcka'
        default:
          return this.event.metadata.handelsetyp
      }
    }
  },

  methods: {
    onClick() {
      this.$store.set('trainChange/active', this.event._id)
    }
  }
}
</script>

<style lang="postcss" module>
.root + .root {
  @apply mt-2;
}

.activeItem {
  border-left: 4px solid theme('colors.primary.default');
}
</style>
